import "../Default.css"
import "./PrivacyPolicy.css"

function PrivacyPolicy() {
    return(
        <>
            <div className="page-title">
                Polityka prywatności
            </div>
            <div className='text privacy-policy'>
                <div className='paragraf'>
                    {"Wyrażam zgodę na przetwarzanie moich danych osobowych (imienia i nazwiska, numeru telefonu, danych dotyczących mojej lokalizacji) przez Związek Harcerstwa Rzeczypospolitej (ZHR) w celu organizacji i koordynacji wyjazdu członków ZHR na Światowe Dni Młodzieży 2023 (ŚDM 2023), w tym poprzez zapewnienie komunikacji elektronicznej w ramach dedykowanej aplikacji mobilnej między członkami ZHR podczas udziału w ŚDM 2023."}
                </div>
                <div className='paragraf'>
                    {"Jestem świadoma/-y, iż niniejsza zgoda jest dobrowolna i może zostać w każdym momencie wycofana poprzez zgłoszenie tego faktu ZHR. Rozumiem, że cofnięcie zgody nie wpłynie na zgodność z prawem przetwarzania, którego dokonano na podstawie zgody przed jej wycofaniem."}
                </div>

                <div className="text-section">
                    <div className="text-box-subheader">
                        {"POLITYKA PRYWATNOŚCI APLIKACJI ŚDM 2023"}
                    </div>
                </div>

                <div className="text-section">
                    <div className="text-box-subheader">
                        <b>&sect;1 POSTANOWIENIA OGÓLNE</b>
                    </div>
                    <ol>
                        <li>
                            {"Polityka prywatności przedstawia postępowanie administratora danych osobowych w zakresie przetwarzania danych osobowych gromadzonych przez dedykowaną aplikację mobilną Światowe Dni Młodzieży 2023, zwaną dalej "}<b>Aplikacją</b>{"."}
                        </li>
                        <li>
                            {"Polityka prywatności ma charakter informacyjny i nie nakłada na Użytkowników żadnych obowiązków."}
                        </li>
                        <li>
                            <b>Administratorem danych osobowych</b>{" w rozumieniu przepisów Rozporządzenia UE 2016/679 Parlamentu Europejskiego i Rady z dnia 27 kwietnia 2016 r. o ochronie osób fizycznych w związku z przetwarzaniem Danych Osobowych i w sprawie swobodnego przepływu takich danych oraz uchylenia Dyrektywy 95/46/EC (zwanego „"}<b>RODO</b>{"”) zbieranych za pośrednictwem Aplikacji jest "}<b>Związek Harcerstwa Rzeczypospolitej</b>{", ul. Litewska 11/13, 00-589 Warszawa, wpisany przez Sąd Rejonowy dla M. St. Warszawy w Warszawie XII Wydział Gospodarczy Krajowego Rejestru Sądowego do Rejestru Stowarzyszeń pod nr 0000057720, zwany w dalszej części „"}<b>Administratorem</b>{"”, adres poczty elektronicznej: kancelaria@zhr.pl."}
                        </li>
                        <li>
                            <b>Użytkownikiem</b>{" jest każda osoba fizyczna zarejestrowana w  Aplikacji."}
                        </li>
                        <li>
                            <b>Danymi osobowymi</b>{" są informacje o zidentyfikowanej lub możliwej do zidentyfikowania osobie fizycznej. "}<b>Przetwarzaniem danych osobowych</b>{" jest niemalże każda czynność dokonywana na danych osobowych. W zakresie nieujętym w niniejszej Polityce prywatności, pojęcia związane z przetwarzaniem danych osobowych należy interpretować zgodnie z definicjami zawartymi w art. 4 RODO."}
                        </li>
                        <li>
                            {"Aplikacja zapewnia bezpieczną transmisję danych przy wykorzystaniu protokołu szyfrowania SSL."}
                        </li>
                        <li>
                            {"Administrator nie korzysta z narzędzi wspierających jego bieżącą działalność, w związku z którymi dane osobowe Użytkownika mogłyby być przekazywane do państwa spoza Europejskiego Obszaru Gospodarczego."}
                        </li>
                    </ol>
                </div>

                <div className="text-section">
                    <div className="text-box-subheader">
                        <b>&sect;2 CEL I ZAKRES ZBIERANIA DANYCH OSOBOWYCH</b>
                    </div>
                    <ol>
                        <li>
                            {"Administrator przetwarza numery IP Użytkowników Aplikacji. Numer IP nie zawsze, lecz pod pewnymi warunkami może być daną osobową."}
                        </li>
                        <li>
                            {"Administrator przetwarza w Aplikacji informacje zapisane w plikach cookies w urządzeniu końcowym Użytkownika i jego pamięci podręcznej."}
                        </li>
                        <li>
                            {"Dane osobowe Użytkowników podawane przy rejestracji w Aplikacji: imię i nazwisko, numer telefonu są przetwarzane przez Administratora wyłącznie w celu organizacji wyjazdu członków Związku Harcerstwa Rzeczypospolitej (ZHR) na obchody Światowych Dni Młodzieży 2023 (ŚDM 2023), koordynacji działań i aktywności podejmowanych przez Użytkowników podczas ŚDM 2023 oraz komunikacji z nimi, a także umożliwienia członkom ZHR uczestnictwa w bieżącej działalności Stowarzyszenia na podstawie zgody Użytkownika (art. 6 ust. 1 lit. a RODO)."}
                        </li>
                        <li>
                            {"Zgoda na przetwarzanie danych osobowych może być w każdej chwili wycofana."}
                        </li>
                        <li>
                            {"Dane Użytkownika przetwarzane będą do momentu wycofania przez Użytkownika zgody na ich przetwarzanie lub usunięcia konta z Aplikacji. ZHR usunie dane osobowe przetwarzane nie później niż do upływu 3 miesięcy od zakończenia ŚDM 2023. Okres przetwarzania danych może być przedłużony w przypadku, gdy przetwarzanie jest niezbędne do ustalenia lub dochodzenia roszczeń lub obrony przed nimi, a po tym czasie jedynie w przypadku i w zakresie, w jakim będą wymagać tego przepisy prawa powszechnie obowiązującego. Po upływie okresu przetwarzania dane są nieodwracalnie usuwane lub zanonimizowane."}
                        </li>
                    </ol>
                </div>

                <div className="text-section">
                    <div className="text-box-subheader">
                        <b>&sect;3 PRZEKAZYWANIE DANYCH PODMIOTOM TRZECIM</b>
                    </div>
                    <div className='paragraf'>
                        {"Dane osobowe Użytkowników będą przekazywane innym Użytkownikom Aplikacji, którzy będą uczestnikami ŚDM 2023. Osoby te nie stają się przez to administratorami danych osobowych innych Użytkowników i nie mogą ich udostępniać. Wymienione podmioty należy traktować jako odbiorców danych osobowych. Przetwarzają dane wyłącznie w zakresie niezbędnym do realizacji celu wyznaczonego przez Administratora oraz mając na względzie zasady zgodności przetwarzania z prawem, rzetelności, przejrzystości, ograniczenia celu przetwarzania, ograniczenia przechowywania, integralności i poufności danych osobowych."}
                    </div>
                </div>

                <div className="text-section">
                    <div className="text-box-subheader">
                        <b>&sect;4 PRAWA UŻYTKOWNIKA W ZAKRESIE OCHRONY DANYCH OSOBOWYCH</b>
                    </div>
                    <ol>
                        <li>
                            {"Użytkownik ma prawo do:"}
                            <ul>
                                <li>
                                    {"dostępu do własnych danych osobowych oraz bezwarunkowego cofnięcia zgody na ich przetwarzanie przez Administratora w każdym czasie bez podania przyczyny, jeśli podstawą przetwarzania danych osobowych jest zgoda podmiotu danych,"}
                                </li>
                                <li>
                                    {"kontroli przetwarzania jego danych osobowych przez Administratora,"}
                                </li>
                                <li>
                                    {"żądania sprostowania jego danych osobowych lub ich aktualizacji,"}
                                </li>
                                <li>
                                    {"żądania usunięcia jego danych osobowych, jeżeli przestały być niezbędne dla celów, dla których zostały zebrane, bądź jeżeli cofnął on zgodę na ich przetwarzanie, a nie zachodzi żadna inna przesłanka przetwarzania danych osobowych,"}
                                </li>
                                <li>
                                    {"żądania przekazania jego danych osobowych w celu ich wykorzystania przez podmioty trzecie,"}
                                </li>
                                <li>
                                    {"wniesienia skargi do Prezesa Urzędu Ochrony Danych Osobowych w przypadku uznania, że przetwarzanie jego danych osobowych narusza przepisy RODO."}
                                </li>
                            </ul>
                        </li>
                        <li>
                            {"Dla realizacji uprawnień wymienionych w §4 ust. 1 Użytkownik powinien skontaktować się z Administratorem poprzez:"}
                            <ul>
                                <li>
                                    {"wysłanie do Administratora określonego żądania drogą mailową na adres poczty elektronicznej – "}<b>kancelaria@zhr.pl</b>
                                </li>
                                <li>
                                    {"wysłanie do Administratora określonego żądania na piśmie na adres: "}<b>Związek Harcerstwa Rzeczypospolitej ul. Litewska 11/13, 00-589 Warszawa</b>
                                </li>
                            </ul>
                        </li>
                    </ol>
                    <div className='paragraf'>
                        {"Nie dotyczy to prawa do wniesienia skargi do Prezesa Urzędu Danych Osobowych, którą można wnieść na adres wskazany na stronie internetowej "}<a href="https://www.uodo.gov.pl" target="blank">www.uodo.gov.pl</a>{"."}
                    </div>
                </div>

                <div className="text-section red-section">
                    <div className="text-box-subheader">
                        <b>&sect;5 PLIKI „COOKIES”</b>
                    </div>
                    <ol>
                        <li>
                            <b>Pliki cookies</b>{" to drobne informacje tekstowe zapisywane w urządzeniu końcowym Użytkownika, takim jak komputer, smartfon, tablet i inne, przeznaczone do korzystania ze stron internetowych. Pozwalają na rozpoznanie urządzenia użytkownika i właściwe wyświetlenie strony internetowej według preferencji użytkownika. Nie zawierają one wirusów ani złośliwego oprogramowania."}
                        </li>
                        <li>
                            {"Pliki cookies używane przez Administratora są zaszyfrowane w sposób uniemożliwiający dostęp do nich osobom nieuprawnionym."}
                        </li>
                        <li>
                            {"Pliki cookies mogą być kontrolowane przez Użytkownika za pomocą ustawień używanej przez niego przeglądarki internetowej w każdym czasie. Szczegółowe informacje dotyczące zmiany ustawień plików cookies Użytkownik może znaleźć zakładkach „pomoc” przeglądarek internetowych."}
                        </li>
                        <li>
                            {"Użytkownik jest informowany o używaniu plików cookies."}
                        </li>
                        <li>
                            {"Administrator stosuje pliki cookies sesyjne (pliki tymczasowe, które są przechowywane w urządzeniu końcowym Użytkownika do czasu wylogowania, opuszczenia Aplikacji."}
                        </li>
                        <li>
                            {"Administrator jest uprawniony do przetwarzania danych zawartych w plikach cookies w następujących celach:"}
                            <ul>
                                <li>
                                    {"utrzymania sesji użytkownika,"}
                                </li>
                                <li>
                                    {"dostosowywania zawartości i funkcjonalności Aplikacji do indywidualnych preferencji,"}
                                </li>
                                <li>
                                    {"audytu logowania."}
                                </li>
                            </ul>
                        </li>
                    </ol>
                    <div className='paragraf'></div>
                </div>

                <div className="text-section">
                    <div className="text-box-subheader">
                        <b>&sect;6 ZMIANY POLITYKI PRYWATNOŚCI</b>
                    </div>
                    <div className='paragraf'>
                        {"Niniejsza Polityka jest na bieżąco weryfikowana i w razie potrzeby aktualizowana. Aktualna wersja Polityki została przyjęta i obowiązuje od dnia 21 lipca 2023."}
                    </div>
                </div>
            </div>
        </>
    )
}

export default PrivacyPolicy;